export const createTimeTrackingEventsMutationKey = [
  "createTimeTrackingEventsMutation",
];
